import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {RQ_BRAND_REGISTER, RQ_DELETE_BRAND, RQ_GET_BRAND_API, RQ_UPDATE_BRAND} from './constants/productBrandConstant';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetBrandAPI = () => {
  return useQuery({
    queryKey: ['rq_get_all_brand'],
    queryFn: async () => {
      const response = await rqCreateRequest(
        RQ_GET_BRAND_API,
        null,
        null,   
        null,
      );
      return response || [];
    },
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQBrandRegistrationAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_brand'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_BRAND_REGISTER,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
  
};

export const RQUpdateBrandAPI = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_brand'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_BRAND.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_UPDATE_BRAND, url},
        formData,
        token,
        null,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_all_brand']});
    },
    ...options,
  });
};

export const RQDeleteBrandAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_delete_brand'],
    mutationFn: async ({token, id}) => {
      if (!token) {throw new Error('Token is required');}
      const url = RQ_DELETE_BRAND.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_DELETE_BRAND, url},
          null, 
          token,
          null, 
          null, 
        );

        return response;
      } catch (error) {
        console.error('Error deleting brand:', error);
        throw error;
      }
    },
    ...options,
  });
};
